var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> <div id="setting_margin" class="setting_margin div100"> <div id="module_margin" class="div100"> <div id="rssCustom" class="rssCustom"> <div style="display:none" id="copymarquee"></div> <div style="background-color:transparent;box-shadow:none" id="marquee"></div> </div> </div> </div> </div>';
}
return __p;
};
